class HowItWorks {
  constructor(container) {
    this.container = container;
    this.swiper = null;
    this.setupElements();
    this.init();
  }

  setupElements() {
    this.swiperEl = this.container.querySelector('.how-it-works__swiper');
  }

  init() {
    if (!this.swiperEl) return;

    if (window.innerWidth <= 990) {
      this.initSwiper();
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth <= 990 && !this.swiper) {
        this.initSwiper();
      } else if (window.innerWidth > 990 && this.swiper) {
        this.destroy();
      }
    });
  }

  initSwiper() {
    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 12
    });
  }

  destroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
      this.swiper = null;
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const sections = document.querySelectorAll('[data-section-type="how-it-works"]');
  sections.forEach(section => new HowItWorks(section));
});

document.addEventListener('shopify:section:load', (event) => {
  if (event.target.querySelector('[data-section-type="how-it-works"]')) {
    new HowItWorks(event.target);
  }
});

document.addEventListener('shopify:section:unload', (event) => {
  const section = event.target.querySelector('[data-section-type="how-it-works"]');
  if (section && section.howItWorksInstance) {
    section.howItWorksInstance.destroy();
  }
});
